var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "emptyStatediv"
  }, [_c('div', {
    staticClass: "emptyStateWrap"
  }, [!_vm.useWithoutVHtml ? [_c('h2', {
    staticClass: "emptyStateTitle"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "emptyStateDescription",
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  })] : _vm._e(), _vm._v(" "), _vm.useWithoutVHtml ? [_c('h2', {
    staticClass: "emptyStateTitle"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "emptyStateText"
  }, [_vm._v(_vm._s(_vm.description))])] : _vm._e(), _vm._v(" "), _vm._t("default")], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }